import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import styled, { css } from 'styled-components';
import { get, isEmpty } from 'lodash-es';
import {
  Heading4,
} from '@docon/docon-ui-library';
import Layout, { MainBody } from 'components/Layout';
import AppointmentCard from 'components/Appointment/components/Card';
import HeaderBar from 'components/Layout/HeaderNavBar';
import HelpSuggestionLists from '../../components/HelpSuggestionLists';
import { getAppointment, updateAppointmentState } from 'redux/reducer/appointment';
import { AlertMsg, Loader } from 'shared';
import { bgColor } from 'utilities/colorConfig';

const AppointmentCardStyled = styled(AppointmentCard)`
  margin-bottom: 30px;
  filter: drop-shadow(0px 3px 6px rgba(0, 41, 77, 0.25));
`;

const Heading = styled(Heading4)`
  padding: 18px 26px 16px;
  font-weight: 600;
  background: ${bgColor.base};
`;

const Root = styled(Layout)`
  position: relative;

  ${MainBody} { padding-top: 0; }

  ${() => isMobileOnly && css`
    ${AppointmentCardStyled} {
      margin-left: 12px;
      margin-right: 12px;
    }

    ${MainBody} { padding: 0; }
  `}
`;

function Appointment({
  history,
}: any) {
  const {
    appointment,
    isFetchingAppointment,
    closingBookingModal,
    appointmentErrors,
  } = useSelector(state => state.appointment);
  const { appointmentId } = useParams<any>();
  const dispatch = useDispatch();

  function getAppointmentData() {
    dispatch(getAppointment({ appointmentId }));
  }

  useEffect(() => {
    return () => {
      dispatch(updateAppointmentState({
        appointmentErrors: {},
      }));
    };
  }, []);

  useEffect(() => {
    getAppointmentData();
  }, [closingBookingModal]);

  const {
    firstName,
    lastName,
    doctorID,
  } = get(appointment, 'doctordetails', {});

  const sessionId = get(appointment, 'teleConsultSessionObject.id', null);
  const paidAmount = get(appointment, 'teleConsultSessionObject.pricing_details.total', 0);
  let errorMsg = '';
  if (!isEmpty(appointmentErrors)) {
    errorMsg = Object.keys(appointmentErrors).map((key: string) => `${get(appointmentErrors, `${key}.messages[0]`, '')}`).join('\n');
  }

  return (
    <Root
      hideFooter={isMobileOnly}
      header={isMobileOnly ? <HeaderBar /> : null}
    >
      {
        isFetchingAppointment ? <Loader /> : (
          <>
            <HeaderBar hidden={isMobileOnly} />
            <Heading title={'Help with this appointment'} />
            <AlertMsg type='error' message={errorMsg} />
            <AppointmentCardStyled
              hidden={errorMsg}
              appointment={appointment}
            />

            <HelpSuggestionLists
              hidden={errorMsg}
              doctorName={`Dr. ${firstName} ${lastName}`}
              doctorID={doctorID}
              sessionId={sessionId}
              appointment={appointment}
              paidAmount={paidAmount}
              history={history}
              onUpdateAppointment={getAppointmentData}
            />
          </>
        )
      }
    </Root>
  );
}

export default Appointment;